import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Composed home card — plan/50 widget catalog (default layout; rearrange later).
 * Sizes: compact (glance chips live inside OwnerGlanceBand) · list · wide.
 */
export function HomeWidget(props: {
  title: string;
  description?: string;
  size?: "list" | "wide";
  children: ReactNode;
  className?: string;
  actions?: ReactNode;
}) {
  const size = props.size ?? "list";
  return (
    <section
      className={cn(
        "rounded-[var(--radius-xl)] border border-[var(--color-border)]/80 bg-[var(--color-card)]/70 p-4 shadow-[var(--shadow-soft)]",
        size === "wide" && "lg:col-span-full",
        props.className,
      )}
      data-home-widget={size}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="m-0 font-[family-name:var(--font-display)] text-base font-semibold tracking-tight text-[var(--color-foreground)]">
            {props.title}
          </h2>
          {props.description ? (
            <p className="mt-1 text-sm text-[var(--color-muted)]">
              {props.description}
            </p>
          ) : null}
        </div>
        {props.actions}
      </div>
      <div className="mt-4">{props.children}</div>
    </section>
  );
}
